@if (patient) {
  <div>
    @if (canViewPatient) {
      <a
        target="_blank"
        routerLink="/capture-admin/patients/{{ patient.id }}"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >{{ visiblePatient.fullName }}</a>
    } @else {
      {{ visiblePatient.fullName }}
    }
  </div>
  @if (showAlternateNames) {
    <div>
      @if (visiblePatient.alternateNames.length > 0) {
        <div>
          <div class="alternate-names"><strong>ALTERNATE NAMES</strong></div>
          @for (alternateName of visiblePatient.alternateNames; track alternateName) {
            <div>
              {{ alternateName }}
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="small text-nowrap"><strong>MRN:</strong> {{ visiblePatient.mrn }}</div>
  <div class="small text-nowrap"><strong>DOB:</strong> {{ visiblePatient.dob | date: 'MM/dd/yyyy' }}</div>
} @else {
  <div><app-blank-value-dash /></div>
}

